import { apiClient } from "../client";

/** One entry of the admin's `social_links` list — shape not pinned down, so
 * both {platform,url} and {name,link} style rows are tolerated. */
export interface SocialLinkEntry {
  platform?: string | null;
  name?: string | null;
  label?: string | null;
  url?: string | null;
  link?: string | null;
  [key: string]: unknown;
}

/** GET /general-settings payload (verified against a live response sample).
 * Unused fields come back as empty strings, not null. */
export interface GeneralSettings {
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  website_url?: string | null;
  support_email?: string | null;
  support_phone?: string | null;
  company_name?: string | null;
  company_logo?: string | null;
  footer_text?: string | null;
  meta_title?: string | null;
  meta_description?: string | null;
  meta_keywords?: string | null;
  whatsapp?: string | null;
  telegram?: string | null;
  youtube?: string | null;
  tiktok?: string | null;
  snapchat?: string | null;
  pinterest?: string | null;
  skype?: string | null;
  fax?: string | null;
  map_embed_url?: string | null;
  social_links?: Array<SocialLinkEntry | string>;
  other?: unknown[];
  /** Which video service NEW live-class rooms open on ("videosdk" |
   * "livekit") — the admin's choice. Informational here: the join payload
   * carries each class's own locked provider, which is what the pages use. */
  live_streaming_provider?: "videosdk" | "livekit" | string;
  /** Same, for 1-1 consultation calls (video & phone bookings). Informational
   * here too: the call page reads the booking's locked provider off the join
   * payload (`bookings.joinCall`). */
  consultation_video_provider?: "videosdk" | "livekit" | string;
  [key: string]: unknown;
}

export interface GeneralSettingsResponse {
  success?: boolean;
  message?: string;
  data?: GeneralSettings;
}

export const generalSettings = {
  /** GET /general-settings — site-wide contact, branding, and social config. */
  get: () => apiClient.get<GeneralSettingsResponse>("/general-settings"),
};
